// extracted by mini-css-extract-plugin
export var background = "hero-module--background--AGe4y";
export var heroImage = "hero-module--heroImage--LRTm+";
export var projectInfo = "hero-module--projectInfo--Y0UIX";
export var actions = "hero-module--actions--9tuXT";
export var projectInfoSocialLinks = "hero-module--projectInfoSocialLinks--ljpvl";
export var projectInfoDescription = "hero-module--projectInfoDescription--IPEUA";
export var projectInfoHeader = "hero-module--projectInfoHeader--4dM12";
export var heroMouseScrollWheel = "hero-module--heroMouseScrollWheel--e8-mq";